import { Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreakdownBannerService {
  constructor(private authService: AuthService) { }

  getBreakdownBanners(userId): Observable<Data[]> {
    return this.authService.getV2CloudFunction('updatebreakdownbannersv2', { userId })?.pipe(
      map(result => result || []),
      catchError(() => of([]))
    );
  }
}
